
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1608212084627",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "5849",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M512 0C229.216 0 0 229.216 0 512s229.216 512 512 512 512-229.216 512-512S794.784 0 512 0z m302.848 470.176a187.424 187.424 0 0 1-105.408 78.656c-1.664 0-1.664 0-3.328 1.664-6.72 1.696-13.376 3.36-21.76 3.36-31.808 0-48.512-21.76-40.16-46.848 6.72-18.4 25.088-35.136 46.848-41.824 35.136-13.376 58.56-41.824 58.56-75.296 0-45.184-43.52-81.984-97.024-81.984-53.568 0-97.088 36.8-97.088 81.984v249.28c0 60.224-35.136 112.128-86.976 142.24-28.448 16.704-61.92 25.088-97.056 25.088-102.08 0-184.064-75.264-184.064-167.328 0-30.112 8.384-56.896 23.424-81.984a187.296 187.296 0 0 1 105.408-78.656c8.384-1.696 15.04-3.328 23.424-3.328 31.808 0 48.512 21.728 40.16 46.848-6.72 18.368-23.424 33.44-43.52 41.792a12.8 12.8 0 0 0-6.688 3.328c-31.808 13.408-53.568 40.192-53.568 73.664 0 45.152 43.52 81.984 97.056 81.984s97.056-36.8 97.056-81.984v-249.312c0-60.224 35.136-112.096 87.008-142.208 28.416-16.736 61.888-25.088 97.024-25.088 102.08 0 184.064 75.264 184.064 167.296 0 26.784-8.384 53.568-23.424 78.656z",
        "p-id": "5850"
      }
    }
  ]
})
    }
  